import React from 'react'

export default () => (
    <div
        className='text-center'
        style={{ paddingBottom: '20px'}}
    >
        No experiences found.
    </div>
)